const normalizeBaseUrl = (value) => String(value || "").trim().replace(/\/+$/g, "");

const getConfiguredBackendUrl = () => {
  if (typeof window !== "undefined" && window.__BACKEND_URL__) {
    return normalizeBaseUrl(window.__BACKEND_URL__);
  }

  return normalizeBaseUrl(process.env.REACT_APP_BACKEND_URL);
};

const resolveDevBackendUrlFromLocation = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const { protocol, hostname, port } = window.location;
  const frontendPort = Number(port);

  if (!Number.isFinite(frontendPort) || frontendPort <= 0) {
    return "";
  }

  return normalizeBaseUrl(`${protocol}//${hostname}:${frontendPort + 1000}`);
};

export const getBackendBaseUrl = () => {
  if (process.env.NODE_ENV === "development") {
    const derivedUrl = resolveDevBackendUrlFromLocation();
    if (derivedUrl) {
      return derivedUrl;
    }
  }

  return getConfiguredBackendUrl();
};

